import {CampaignProps} from '@/types/campaign';
import {BriefFieldManagerAttributes} from '@/views/campaigns/brief/brief-field-manager/BriefFieldManager';
import BriefField from '@/views/campaigns/brief/brief-field-manager/brief-field/BriefField';
import DeliverablesBriefItem from '@/views/campaigns/brief/brief-field-manager/brief-field/DeliverablesBriefItem';
import getBriefDeliverableCounters from '@/views/campaigns/brief/utils/getBriefDeliverableCounters';

class CampaignBriefDeliverableItems extends BriefField {
  briefFieldManager: BriefFieldManagerAttributes;

  constructor(
    briefFieldManager: BriefFieldManagerAttributes,
    campaignData: CampaignProps,
    key: string,
    value: any
  ) {
    super(briefFieldManager, campaignData, key, value);
    this.briefFieldManager = briefFieldManager;
  }

  set value(value: any) {
    super.value = value;
    if (this.briefFieldManager.fields.deliverablesBriefItem) {
      (
        this.briefFieldManager.fields
          .deliverablesBriefItem as DeliverablesBriefItem
      ).campaignBriefDeliverableItems = value;
    }
    const counters = getBriefDeliverableCounters(value);
    Object.entries(counters).forEach(([counterKey, counterValue]) => {
      this.briefFieldManager.fields[counterKey].value = counterValue;
    });
  }

  get value() {
    return super.value;
  }
}

export default CampaignBriefDeliverableItems;
